import { applyMiddleware, createStore } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import thunk from "redux-thunk";
import reducers from "./reducer";

const userInfoFromStorage = localStorage.getItem("userInfo")
  ? JSON.parse(localStorage.getItem("userInfo"))
  : null;
const themeStorage = localStorage.getItem("theme");
const companyName = localStorage.getItem("companyName")
  ? JSON.parse(localStorage.getItem("companyName"))
  : null;
const versionStorage = localStorage.getItem("version");

const initialState = {
  userLogin: { userInfo: userInfoFromStorage },
  ThemeToggler: { themeDisplay: themeStorage },
  CurrentCompany: { company: companyName },
  AppVersion: { version: versionStorage },

};

const middleware = [thunk];

const store = createStore(
  reducers,
  initialState,
  composeWithDevTools(applyMiddleware(...middleware))
);

export default store;
